// reactstrap components
import {NavLink} from "react-router-dom";

import {Container, Nav, NavItem} from "reactstrap";

const Footer: React.FC = () => (
  <footer className="footer">
    <Container fluid>
      <Nav>
        <NavItem>
          <NavLink to="/termsofuse" className="nav-link">
            Terms Of Use
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink to="/privacy" className="nav-link">
            Privacy Notice
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink to="/contact" className="nav-link">
            Contact
          </NavLink>
        </NavItem>
      </Nav>
      <div className="copyright">Version 3.0.0 &copy; Torque Advisory LLC {new Date().getFullYear()}</div>
      <div className="clearfix"></div>
    </Container>
  </footer>
);

export default Footer;
